import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Quando devo procurar assessoria jurídica preventiva?",
    a: "Sempre que houver riscos contratuais, trabalhistas, previdenciários, empresariais ou patrimoniais que possam gerar prejuízos futuros. A prevenção reduz riscos e evita custos maiores.",
  },
  {
    q: "O escritório atende empresas e pessoas físicas?",
    a: "Sim. Atuamos de forma estratégica tanto para pessoas físicas quanto para empresas de diferentes segmentos.",
  },
  {
    q: "O escritório atua apenas em processos judiciais?",
    a: "Não. Também desenvolvemos atuação consultiva e preventiva, auxiliando clientes na tomada de decisões seguras e na mitigação de riscos.",
  },
  {
    q: "Como funciona o atendimento?",
    a: "O atendimento é realizado de forma personalizada, com análise individual de cada demanda e definição da melhor estratégia jurídica para o caso.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="section bg-white" data-testid="section-faq">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="mb-14 text-center">
          <p className="eyebrow text-brand-accent mb-5">FAQ</p>
          <h2 className="font-serif text-brand-primary font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Perguntas <em className="not-italic text-brand-accent">Frequentes</em>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full divide-y divide-brand-primary/10 border-y border-brand-primary/10">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-brand-primary hover:no-underline py-6 hover:text-brand-accent2 [&[data-state=open]]:text-brand-primary">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[14px] leading-relaxed text-brand-text/80 pb-6 pr-10">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
